// @ts-nocheck
import productDetailsReducer, {
    BunzlPagesProductDetailsActions,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsReducer";
import { combineReducers, Dispatch } from "redux";

/* Bunzl Custom Code - Start */
import bulkListReducer, { BulkListActions } from "@store/Framework/Store/Bunzl/Pages/BulkLists/BulkListReducer";
import buyingListReducer, { BuyingListActions } from "@store/Framework/Store/Bunzl/Pages/BuyingList/BuyingListReducer";
import addToListReducer, { AddToListActions } from "@store/Framework/Store/Bunzl/Pages/Header/AddToListReducer";
import categoryReducer, {
    MyListDetailsCategoryActions,
} from "@store/Framework/Store/Bunzl/Pages/MyListDetails/MyListDetailsCategoryReducer";
import ReportAPIReducer, {
    InvoiceDetailActions,
    InvoiceSummaryActions,
    ReportAPIactions,
} from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportApi/ReportAPIReducer";
import reportOrderFrequencyReducer, {
    BunzlPagesReportOrderHistoryActions,
} from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencyReducer";
import signatureReducer, { SignatureActions } from "@store/Framework/Store/Bunzl/Pages/Signature/SignatureReducer";
import StepFormReducer, { StepFormActions } from "@store/Framework/Store/Bunzl/Pages/StepForm/StepFormReducer";
import PromotionTreeReducer, {
    PromotionTreeActions,
} from "@store/Framework/Store/Pages/PromotionTree/PromotionTreeReducer";
import AccountBalanceReducer, {
    AccountBalanceActions,
} from "@store/Framework/Store/Pages/AccountBalance/AccountBalanceReducer";
import { useDispatch } from "react-redux";
import productDetailsZoomReducer, {
    ProductDetailsZoomActions,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetailsZoom/ProductDetailsZoomReducer";
import dynamicSearchWidthReducer, {
    DynamicSearchWidthActions,
} from "@store/Framework/Store/Bunzl/Pages/Header/DynamicSearchWidthReducer";
import changeCustomerReducer, {
    ChangeCustomerActions,
} from "@store/Framework/Store/Pages/ChangeCustomer/ChangeCustomerReducer";
import bunzlExtraAccountSettingsReducer, {
    BunzlExtraAccountSettingsActions,
} from "@store/Framework/Store/Bunzl/Pages/AccountSettings/BunzlExtraAccountSettingsReducer";

const { reportAPIReducer, invoiceSummaryReducer, invoiceDetailReducer } = ReportAPIReducer;
/* Bunzl Custom Code - End */

const pagesReducers = {
    productDetails: productDetailsReducer,
    // Bunzl Custom Code
    buyingList: buyingListReducer,
    ReportAPI: reportAPIReducer,
    invoiceDetail: invoiceDetailReducer,
    invoiceSummaryReportData: invoiceSummaryReducer,
    reportOrderFrequency: reportOrderFrequencyReducer,
    Signature: signatureReducer,
    promotionTree: PromotionTreeReducer,
    bulkLists: bulkListReducer,
    stepForm: StepFormReducer,
    myListDetailsCategory: categoryReducer,
    addToList: addToListReducer,
    dynamicSearchWidth: dynamicSearchWidthReducer,
    productDetailsZoom: productDetailsZoomReducer,
    accountBalance: AccountBalanceReducer,
    changeCustomer: changeCustomerReducer,
    accountSettings: bunzlExtraAccountSettingsReducer,
};

/* Bunzl Custom Code - Start */
export type BunzlPagesActions =
    | ProductDetailsZoomActions
    | StepFormActions
    | BunzlPagesProductDetailsActions
    | BuyingListActions
    | InvoiceDetailActions
    | ReportAPIactions
    | InvoiceSummaryActions
    | BunzlPagesReportOrderHistoryActions
    | SignatureActions
    | PromotionTreeActions
    | BulkListActions
    | MyListDetailsCategoryActions
    | AccountBalanceActions
    | AddToListActions
    | DynamicSearchWidthActions
    | ChangeCustomerActions
    | BunzlExtraAccountSettingsActions;

/* Bunzl Custom Code - End */
export default combineReducers(pagesReducers);
